import { render } from "./UiHeading.vue?vue&type=template&id=16063fc0"
import script from "./UiHeading.vue?vue&type=script&lang=js"
export * from "./UiHeading.vue?vue&type=script&lang=js"

import "./UiHeading.vue?vue&type=style&index=0&id=16063fc0&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__